import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import Modal from "../../../../../../components/modal/Modal";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';

interface RenaissanceHistoryPageProps {
}

const RenaissanceHistoryPage = (props: RenaissanceHistoryPageProps) => {

    const _map_src = `chase/world/geography/casarok_post_cataclysm.png`;

    const page: PageActions = new PageActions({
        title: `Casarok History: Renaissance Age - Chase the Fox`,
        description: "The Renaissance Age of Casarok is a period of rapid scientific advancement after the Great Cataclysm!",
        keywords: ["casarok", "casarok history", "reemergence age", "fantasy timeline", "fantasy world history", "fantasy renaissance age"],
        imgSrc: _map_src,
        url: `world/history/renaissance-age`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="geography-modal-view">
                    <p className="center">
                        <a href={_image_service.getCdnImageSrc(_map_src, 'full')}
                           target="_blank"
                           rel="noopener noreferrer">
                            Click here to view the full size image.
                        </a>
                    </p>
                    <img src={_image_service.getCdnImageSrc(_map_src, 'desktop')}
                         title='Casarok Post-Cataclysm Map'
                         alt="A map of Casarok after the Great Cataclysm"/>
                </div>
            </Modal>
            <ContentBox header="The Renaissance Age of Casarok">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <a id="visible-element"
                       className="switch-visible geography-modal-link"
                       onClick={() => setModalIsOpen(true)}>
                        <img className="block width-50-percent"
                             src={_image_service.getCdnImageSrc(`chase/world/geography/casarok_post_cataclysm.png`)}
                             title='Casarok Post-Cataclysm Map'
                             alt="A map of Casarok after the Great Cataclysm"/>
                    </a>
                </div>
                <div className="world-page-static">
                    <p className="center">
                        <em>This age covers the years 1000 - 1300 ACE.</em>
                    </p>
                    <p>
                        The Renaissance Age was a time of scientific enlightenment across Casarok. Building from the
                        technological shift that started during
                        the <NavLink className="world-link" to='/world/history/reemergence-age'>Reemergence Age</NavLink>, many
                        new inventions were created in this time. Culture began to shift away from being centralized
                        around the religions founded in the previous age toward science, law, and philosophy. Creative
                        works of the time are said to be considered the most important literature of all time as well.
                    </p>
                    <p>
                        This era of Casarokan history was not without its conflict though. Gunpowder weaponry was
                        quickly becoming imperative to defense in Centralia and Euraline, other gunpowder weapons were
                        being developed in nations that once had access to it, and advanced magics were being created
                        in the western world. The improvements in the creation and distribution
                        of <NavLink className="world-link" to='/world/magic/items/bulletguard'>bulletguards</NavLink> were
                        vital to keep up with the rapid development of gunpowder.
                    </p>
                    <p>
                        <em>How does Casarok's Renaissance Age differ from the same time period of Earth?</em><br/>
                        There is little difference aside from the existence of magic. Sequea and the Phaerolian
                        continent had more access to livestock than the similar areas on Earth around this time.
                    </p>
                    <h3 className="headline">Notable Events</h3>
                    <ul className="spaced">
                        <li>
                            <em>1010 ACE</em>: Fast advancements in the studies of focal lenses give way to glasses,
                            the microscope, and the telescope.
                        </li>
                        <li>
                            <em>1059 ACE</em>: The International Council of Magic declares 12 mage towers as capital
                            mage towers, those responsible for their elemental specialization.
                        </li>
                        <li>
                            <em>1136 ACE</em>: The arquebus becomes the primary weapon for infantry in nations on
                            Centralia and Euraline.
                        </li>
                        <li>
                            <em>1194 ACE</em>: The bulletguard sees widespread use in nations with gunpowder access.
                        </li>
                        <li>
                            <em>1234 ACE</em>: Primitive steam engines are invented.
                        </li>
                        <li>
                            <em>1268 ACE</em>: Ships become capable of traveling from Euraline to the Phaerolian
                            continent.
                        </li>
                        <li>
                            <em>1273 ACE</em>: Primitive clockwork technology is developed for use in early machines.
                        </li>
                        <li>
                            <em>1288 ACE</em>: Steam engines are employed in ships to reach further destinations.
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default RenaissanceHistoryPage;